import { StrictMode } from "react"

import AuthGuard from "./components/AuthGuard"
import { DebugBar } from "./components/DebugBar"
import { AuthProvider, useAuth } from "./hooks/useAuth"
import { useConnections } from "./hooks/useConnections"
import { usePlaidConnection } from "./hooks/usePlaidConnection"

const Welcome = () => {
  const { user, error } = useAuth()
  const { connections, disconnect } = useConnections()
  const {
    connect,
    loading: plaidLoading,
    error: plaidError,
  } = usePlaidConnection()

  /* TODO(arie): use pages instead*/
  if (error) {
    console.error(error)
  }
  const profilePicture = user?.photoURL ? (
    <img
      width={64}
      height={64}
      src={user.photoURL}
      alt="Profile Picture"
      referrerPolicy="no-referrer"
    />
  ) : null
  return (
    <>
      <h1>Gadol</h1>
      <h2>Welcome to {import.meta.env.VITE_FIREBASE_PROJECT_ID}</h2>
      {profilePicture}
      <div>
        <b>{user?.displayName}</b>
      </div>
      <div>{user ? user.email : "None"}</div>

      <div className="mt-6 flex max-w-lg flex-col gap-3">
        <button
          onClick={connect}
          disabled={plaidLoading}
          className="rounded bg-blue-600 px-4 py-2 text-white disabled:opacity-50"
        >
          {plaidLoading ? "Connecting…" : "+ Connect Bank"}
        </button>
        {plaidError && (
          <p className="text-sm text-red-500">{plaidError.message}</p>
        )}
        {connections.map((c) => (
          <details
            key={c.oid}
            className="rounded border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800"
          >
            <summary className="flex cursor-pointer items-center justify-between px-4 py-3 text-sm font-medium">
              <span>{c.displayName}</span>
              <button
                onClick={(e) => {
                  e.preventDefault()
                  void disconnect(c.oid)
                }}
                className="ml-4 text-xs text-red-500 hover:text-red-700"
              >
                Disconnect
              </button>
            </summary>
            <pre className="overflow-x-auto border-t border-gray-200 px-4 py-3 text-left text-xs dark:border-gray-700">
              {JSON.stringify(c, null, 2)}
            </pre>
          </details>
        ))}
      </div>
    </>
  )
}

function App() {
  return (
    <StrictMode>
      <AuthProvider>
        <AuthGuard>
          <Welcome />
        </AuthGuard>
        <DebugBar />
      </AuthProvider>
    </StrictMode>
  )
}

export default App
